import React from 'react';
import { AggregatedData } from './aggregateData';

export const AggregatedReportDataContext = React.createContext<AggregatedData | null>({
  teams: {},
  respondents: {},
});
